import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { PermissionService } from '../services/permission.service';
import { environment } from '../../../environments/environment';

export const menuAccessGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  // If feature flag is off, allow all
  if (!environment.usePermissionMenu) {
    return true;
  }

  // If permissions not loaded yet, allow (don't block during initial load)
  if (!permissionService.isActive()) {
    return true;
  }

  const menuKey = route.data?.['menuKey'] as string;
  if (!menuKey) return true;

  if (permissionService.canAccess(menuKey)) {
    return true;
  }

  // Denied — redirect to no-access (createUrlTree is safe, no infinite loop)
  return router.createUrlTree(['/main/dashboard/no-access']);
};
